import { Component, ViewChild } from '@angular/core';
import { InvApiService } from '../../API/invapi.service';
import { TableHeadsService } from '../../Core/tableheads.service';
import { IMyDateModel, IAngularMyDpOptions } from 'angular-mydatepicker';
import { Router, NavigationEnd, ActivatedRoute, RoutesRecognized } from '@angular/router';
import { PageHeaderComponent } from '../../Core/pageheader.component';
import { AppComponent } from '../../app.component';
import { PreviousRouteService } from 'src/app/Core/services/previous-route.service';
import { AuthService } from 'src/app/API/auth.service';
import { Observable } from 'rxjs';
import { CommonApiService } from 'src/app/API/commonapi.service.';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PartListHistoryDialog } from 'src/app/Core/PartListHistory/PartListHistoryDialog';
import { QuantityManagementDialogComponent } from '../QuantityManagementDialog/quantity-management-dialog/QuantityManagementDialog.component';
import { PartsInventoryComponent } from 'src/app/Core/Shared/PartsInventoryComponent/PartsInventoryComponent';
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";

@Component({
  selector: 'InventoryPartList',
  templateUrl: './InventoryPartList.component.html'
})
export class InventoryPartListComponent {
  UserList: any;
  DivisionList = [];
  VendorList = [];
  page;
  CategoryList = [];
  ManufacturerList = [];
  ModelList = [];
  partListHistoryDialogRef: MatDialogRef<PartListHistoryDialog>;
  QuantityManagementDialogComponentRef: MatDialogRef<QuantityManagementDialogComponent>;
  constructor(
    private invapi: InvApiService,
    private router: Router,
    private route: ActivatedRoute,
    private dataGridService: TableHeadsService,
    private previousRouteService: PreviousRouteService,
    private auth: AuthService,
    private commonapi: CommonApiService,
    public dialog: MatDialog,
    private breakpointObserver: BreakpointObserver
  ) {
    this.page = new InventorySearchPage();
    this.page.pageNumber = 0;
    this.page.size = 25;
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean  {
    this.invapi.setSearchValue(this.page);
    return true;
  }

  @ViewChild(PageHeaderComponent, { static: true })
  pageheader: PageHeaderComponent;
  loading = true;
  StatusList = [
    { value: '', text: 'Select' },
    { value: 'Inservice', text: 'Inservice' },
    { value: 'Active', text: 'Active' },
    { value: 'Inactive', text: 'Inactive' }
  ];
  TypeList = [
    { value: '', text: 'Select' },
    { value: 'PARTS', text: 'PARTS' },
    { value: 'EQUIPMENT', text: 'EQUIPMENT' }
  ];
  blnDirtySearch = false;
  tableHeaders;
  rows;
  AddUrl = 'Inventory/InventoryDetail';
  ShowSearch = false;
  title = "Inventory Part List";;
  searchText = 'Search Records';
  defaultSort;
  previousUrl: string;
  isMobile = this.breakpointObserver.isMatched(Breakpoints.Handset);
  // tslint:disable-next-line:member-ordering
  public myOptions: IAngularMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
    closeSelectorOnDateSelect: false
  };

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnInit() {
     this.page.manufacturerId = '';
     this.page.modelId = '';

    this.auth.GetCurrentUserDivision().subscribe(division => {
      let searchedPage = this.invapi.getSearchValue();

      this.dataGridService.clearHeader();
      this.dataGridService.addHeader('#', 'equipmentcode', '4');
      this.dataGridService.addHeader('Product/Part Id', 'equipmentcode', '11');
      this.dataGridService.addHeader('Product/Part Name', 'equipmentname', '30');
      //this.dataGridService.addHeader('Type', 'equipmenttype', '8');
      //this.dataGridService.addHeader('Category', 'category', '12');
      this.dataGridService.addHeader('Model', 'model', '14');
      this.dataGridService.addHeader('Vendor', 'vendor', '20');
      this.dataGridService.addHeader('Status', 'status', '8');
      this.dataGridService.addHeader('Part Quantity', 'quantity', 12);
      this.dataGridService.addHeader('Item Cost', 'itemcost', '12');
      this.dataGridService.addHeader('Action', 'History', '12');
      this.tableHeaders = this.dataGridService.setTableHeaders();
      this.defaultSort = this.dataGridService.setDefaultSort('Product/Part Id', false);
      // this.FillDivision();
      this.FillVendor();
      this.CheckDirtySearch();
      this.fillCategories();
      this.fillAndSetModelList();

      // const test = this.route.queryParams.subscribe(params => {
      //   // Defaults to 0 if no query param provided.
      //   if (params && params['previousSerach']) {
      //     if (searchedPage) {
      //       this.page = searchedPage;
      //       this.executeInventorySearch();
      //     }
      //   }
      // });

      let previousUrl = this.previousRouteService.getPreviousUrl();
      if (searchedPage && previousUrl && previousUrl.includes(this.AddUrl)
      
      ) {
        this.page = searchedPage;
        this.FillDivision();
      }
      else {
        if (division.length === 1){
          this.FillDivision(division[0]);
        }
        else{
          this.FillDivision();
        }
      }
      AppComponent.HideLoader();
    }, error => {
      AppComponent.addAlert(error.message, 'error');
      AppComponent.HideLoader();
    });
  }

  FillDivision(defaultValue = '') {
    // this.invapi.FillDivision().subscribe(list => {
      this.commonapi.FillDivision(true).subscribe(list => {

      const unassignedOption = { value: '0', text: 'Unassigned' };
      this.DivisionList = [...list, unassignedOption]; // Append at the end

      if (defaultValue) {
        this.page.Division = defaultValue;
        this.executeInventorySearch();
      }
      else{
        this.executeInventorySearch();
      }
    });
  }

  FillVendor() {
    this.invapi.FillVendorList().subscribe(list => {
      this.VendorList = list;
    });
  }

  fillCategories() {
    this.invapi.FillCategoryList().subscribe(list => {
      this.CategoryList = list;
    });
  }
  
  fillManufacturers() {
    const categoryId = { Id: this.CategoryList.find(c=>c.text == this.page.Category).value };

    this.invapi.FillManufacturerList(categoryId).subscribe(list => {
      this.ManufacturerList = list;
    });
  }

    fillAndSetModelList() {
      if (this.page.manufacturerId != "") {     
        this.fillModelList();
      } 
    }


    fillModelList() {
      const CategoryManufacturerId = { categoryId: this.CategoryList.find(c=>c.text == this.page.Category).value
        , manufacturerId:this.page.manufacturerId};
      this.invapi
        .FillModels(CategoryManufacturerId)
        .subscribe(list => (this.ModelList = list));
    
  }

  onSearchShowChange(value) {
    this.ShowSearch = value;
  }

  changeSorting(column) {
    if (column === '#') {
      return;
    }

    this.dataGridService.changeSorting(
      column,
      this.defaultSort,
      this.tableHeaders
    );
    this.defaultSort = this.dataGridService.getSort();
    this.page.sortDirection = this.dataGridService.getSortDirection();
    this.page.sortExpression = this.dataGridService.getSortExpression();
    this.page.currentPageNumber = 1;
    this.page.pageNumber = 0;
    this.executeInventorySearch();
  }

  setSortIndicator = function (column) {
    return this.dataGridService.setSortIndicator(column, this.defaultSort);
  };

  executeInventorySearch() {
    AppComponent.ShowLoader();
    this.pageheader.isSearchOpen = false;
    this.pageheader.searchText = 'Search Records';
    this.ShowSearch = false;
    this.searchText = 'Search Records';
    this.CheckDirtySearch();
    const InventorySearch = this.prepareSearch();
    this.invapi.GetInventoryPartList(InventorySearch).subscribe(
      pagedData => {
        this.page.totalElements = pagedData.totalRows;
        this.page.totalPages = pagedData.totalPages;        
        this.rows = pagedData.inventoryPartDetails;
        AppComponent.HideLoader();
      },
      error => {
        AppComponent.addAlert(error.message, 'error');
        AppComponent.HideLoader();
      }
    );
  }


  prepareSearch() {
    const InventorySearch = <any>{};

    InventorySearch.itemCode = this.page.ProductId;
    InventorySearch.priorItemCode = this.page.PriProductId;
    InventorySearch.name = this.page.ProductName;
    InventorySearch.desc = this.page.ProductDesc;

    if (this.page.Category !== undefined && this.page.Category !== '' && this.page.Category !== '0') {
      InventorySearch.Category = this.page.Category;
    }

    if (this.page.manufacturerId !== undefined && this.page.manufacturerId !== '' && this.page.manufacturerId !== '0') {
      InventorySearch.manufacturerId = this.page.manufacturerId;
    }

    if (this.page.modelId !== undefined && this.page.modelId !== '' && this.page.modelId !== '0') {
      InventorySearch.modelId = this.page.modelId;
    }

    if (this.page.Vendor !== undefined && this.page.Vendor !== '' && this.page.Vendor !== '0') {
      InventorySearch.vendorId = this.page.Vendor;
    }

    if (this.page.Division !== undefined && this.page.Division !== '' && this.page.Division != 'All Divisions') {
      InventorySearch.divisonid = this.page.Division;
    }

    if (this.page.SelectedType !== undefined && this.page.SelectedType !== '') {
      InventorySearch.type = this.page.SelectedType;
    }
    if (this.page.Status !== undefined && this.page.Status !== '') {
      InventorySearch.status = this.page.Status;
    }
    InventorySearch.currentPageNumber = this.page.currentPageNumber;
    InventorySearch.sortExpression = this.page.sortExpression;
    InventorySearch.sortDirection = this.page.sortDirection;
    InventorySearch.pageSize = this.page.pageSize;

    // this.invapi.setSearchValue(this.page);

    return InventorySearch;
  }

  setPage() {
    this.page.currentPageNumber = this.page.pageNumber;
    this.executeInventorySearch();
  }
  
  onDateChanged(event: IMyDateModel): void {
    // date selected
  }

  executeInventorySearchClear() {
    this.page.Status = '';
    this.page.ProductId = '';
    this.page.PriProductId = '';
    this.page.ProductName = '';
    this.page.ProductDesc = '';
    this.page.Vendor = '';
    this.page.Division = '';
    this.page.SelectedType = '';
    this.page.Category = 'Select';
    this.page.manufacturerId = '';

    this.executeInventorySearch();
  }

  CheckDirtySearch() {
    this.blnDirtySearch = false;
    if (
      this.page.ProductId ||
      this.page.PriProductId ||
      this.page.ProductName ||
      this.page.ProductDesc ||
      this.page.Vendor ||
      (this.page.Division && this.page.Division != 'All Divisions') ||
      this.page.SelectedType ||
      this.page.Status ||
      this.page.Category != 'Select'
    ) {
      this.blnDirtySearch = true;
    }
    return this.blnDirtySearch;
  }

  DialysisUnitDropDownChanged() {
    this.executeInventorySearch();
  }

  hideSearch() {
     this.ShowSearch = false;
  }
  
    _onRowClick(EquipId, equipmentdesc, SerialNo, Name, InserviceDate, PMStatusHours, PMStatusType, availableQuantity) {

      this.partListHistoryDialogRef = this.dialog.open(PartListHistoryDialog, {
        disableClose: true,
        position: { right: '0', top: '0' },
        //width: '35%',
        width: this.isMobile ? '70vw' : '35%',
        maxWidth: this.isMobile ? '70vw' : '35vw',
        height: '100%',
        data: {
          EquipId,
          EquipDesc: equipmentdesc,
          AvailableQuantity: availableQuantity,
          MachineName: Name,
          DivisionId: this.page.Division
        },
      });

      this.partListHistoryDialogRef.afterClosed().subscribe(() => {
        this.partListHistoryDialogRef = null;
      });
    }

     openQuantityPopup(quantity, equipementid) {
      this.QuantityManagementDialogComponentRef = this.dialog.open(QuantityManagementDialogComponent, {
        disableClose: true,
        position: { right: '0', top: '0' },
        height: '100%',
        //width: '34%',
         width: this.isMobile ? '50vw' : '34%',
        maxWidth: this.isMobile ? '50vw' : '35vw',
        maxHeight: '100vh',
        data: {
          quantity: quantity,
          equipementId: equipementid,
          fromInventoryPage: false
        }
      });

      this.QuantityManagementDialogComponentRef.afterClosed().subscribe((result) => {
        if (result) {
          // optional: refresh data after quantity change
          this.executeInventorySearch();
        }
      });
  }

  onEquipmentClick(item: any): void {
    const id = item.equipementid;
    this.router.navigate(['/Inventory/InventoryDetail'], {
        queryParams: { id, from: 'InventoryPartList' }
    });
  }

  openInventory(InventoryDetail) {
      
      const dialogRef =  this.dialog.open(PartsInventoryComponent, {
        disableClose: true,
        position: { right: '0', top: '0' },
        height: '100%',
        //width:  '120%',
        width: this.isMobile ? '100vw' : '120%',
        maxWidth: this.isMobile ? '100vw' : '180vh',
        //maxWidth:  '180vh' ,
        data: { equipementid: InventoryDetail.equipementid, equipmentcode : InventoryDetail.equipmentcode,
                equipmentDesc: InventoryDetail.equipmentdesc,
                isDialogFromPartsComponent: true }
      });
  
      dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.executeInventorySearch();
          }
      });
    }
}

export class InventorySearchPage {
  // The number of elements in the page
  size = 0;
  // The total number of elements
  totalElements = 0;
  // The total number of pages
  totalPages = 0;
  // The current page number
  pageNumber = 0;

  pageSize = 25;

  ProductId: string;
  Category = 'Select';
  PriProductId: string;
  ProductName: string;
  ProductDesc: string;
  Vendor = '';
  Division = '';
  SelectedType = '';
  Status = '';
  currentPageNumber = 1;
  sortExpression = '';
  sortDirection = '';
}
